import {
  GET_CURRENT_USER,
  GET_USER_NOTIFICATION_PREFERENCES,
  UPDATE_USER_NOTIFICATION_PREFERENCE,
  EnhancedUserActionTypes,
  GetUserNotificationPreferencesAction,
  UpdateUserNotificationPreferenceAction,
  UserNotificationPreference,
} from './types';

export const creators = {
  getCurrentUser(): EnhancedUserActionTypes {
    return { type: GET_CURRENT_USER };
  },
  getUserNotificationPreferences(): GetUserNotificationPreferencesAction {
    return { type: GET_USER_NOTIFICATION_PREFERENCES };
  },
  updateUserNotificationPreference(
    notificationPreference: UserNotificationPreference,
  ): UpdateUserNotificationPreferenceAction {
    return {
      type: UPDATE_USER_NOTIFICATION_PREFERENCE,
      notificationPreference,
    };
  },
};

export default creators;
